module.exports = __webpack_public_path__ + "img/logo-dls.f82d3510.png";